/* CreateEditRedactionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const _ = require("lodash");
const Renderer = require("./CreateEditRedactionRenderer");
/**
 * @class CreateEditRedactionComponent
 * @extends EventEmitter
 *
 * @fires CreateEditRedactionComponent#Data
 * @fires CreateEditRedactionComponent#Error
 * @fires CreateEditRedactionComponent#Shutdown
 */
class CreateEditRedactionComponent extends EventEmitter {
    constructor(data) {
        super();
        this._data = data;
        this._redactionEntityDef = this._data.RedactionEntity;
        this._activeOrgId = this._data.orgId;
        this._modelUserFeedback = this._data.muf;
        this._redactionEntity = this._data.redactionEntity || {};
        this._registerListeners();
        this._renderer = new Renderer(this);
    }
    get renderer() {
        return this.getRenderer();
    }
    get rootElement() {
        return this._renderer.getRootElement();
    }
    get activeOrgId() {
        return this._activeOrgId;
    }
    get userFeedback() {
        return this._userFeedback;
    }
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    _shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();
        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = undefined;
                this._shutdownProm = undefined;
                this._data = undefined;
                this.removeAllListeners();
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }
    _whenModelIsReady() {
        this._redactionEntityInst = _.isEmpty(this._redactionEntity)
            ? new this._redactionEntityDef(this.activeOrgId)
            : this._redactionEntity;
        return Promise.resolve();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }
    closePopUp() {
        this.rejectPopUp({userRejected: true});
    }
    async saveandclosePopUp() {
        let errored = false;
        try {
            this._redactionEntityInst.isSynchronized()
                ? await this._redactionEntityInst.update()
                : await this._redactionEntityInst.create();
        } catch (err) {
            errored = true;
            console.log(err);
            let msg = err.errorMsg;
            if (err.errorCode === "EntityAlreadyExists") {
                msg = msg
                    .replace("RedactionRegex", "Redaction Expression")
                    .replace("named ", 'named "')
                    .replace(" already", '" already');
            }
            this.emit("Error", msg);
        } finally {
            if (!errored) {
                this.closePopUp();
            }
        }
    }
    resolvePopup(data) {
        this._context.resolve(data);
    }
    rejectPopUp(data) {
        this._context.reject(data);
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = CreateEditRedactionComponent;
